"use client";
import { FC } from "react";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import Bounded from "@/components/componentsV2/shared-components/Bounded";
import SupportServiceCta from "@/app/(landing)/mental-health/components/support-service-cta";
import { motion } from "framer-motion";

/**
 * Props for `SupportAfterReportingSection`.
 */
export type SupportAfterReportingSectionProps =
  SliceComponentProps<Content.SupportAfterReportingSectionSlice>;

/**
 * Component for "SupportAfterReportingSection" Slices.
 */
const SupportAfterReportingSection: FC<SupportAfterReportingSectionProps> = ({
  slice,
}) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {slice.variation === "default" ? (
        <Bounded className="py-20">
          {/* heading */}
          <motion.div
            className="space-y-8 text-primary mb-8"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <PrismicRichText
              field={slice.primary.heading}
              components={{
                heading1: ({ children }) => (
                  <h1 className="text-4xl lg:text-5xl font-semibold md:text-center">
                    {children}
                  </h1>
                ),
                label: ({ node, children }) => {
                  if (node.data.label === "Highlight") {
                    return <span className="text-secondary">{children}</span>;
                  }
                },
              }}
            />

            <PrismicRichText
              field={slice.primary.sub_heading}
              components={{
                paragraph: ({ children }) => (
                  <p className="text-xl font-merriweather md:text-center">
                    {children}
                  </p>
                ),
              }}
            />
          </motion.div>

          {/* cta */}

          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <SupportServiceCta data={slice.primary} />
          </motion.div>
        </Bounded>
      ) : null}
    </section>
  );
};

export default SupportAfterReportingSection;
